export const getSize = (octets: number): { size: number; unit: string } => {
  if (octets > 999999) {
    return { size: Math.floor(octets / 100000) / 10, unit: 'mo' };
  } else if (octets > 999) {
    return { size: Math.floor(octets / 100) / 10, unit: 'ko' };
  }
  return { size: Math.floor(octets), unit: 'o' };
};
